module.exports = __webpack_public_path__ + "static/Football-black-ossystem-1d459cca4dfada7876b2cc88df5cb04c.jpg";